import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent disabled:opacity-50 disabled:pointer-events-none rounded-lg';
  const variants = {
    primary: 'bg-accent text-white hover:bg-accent-dark shadow-lg hover:shadow-xl',
    secondary: 'bg-card text-text-primary border border-border hover:bg-border hover:border-text-muted shadow-md',
    outline: 'bg-transparent border-2 border-accent text-accent hover:bg-accent hover:text-white'
  };
  const sizes = {
    md: 'h-12 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className || ''}`} {...props} data-id="element-310">
      {children}
    </motion.button>;
}